const LIMIT_LABELS: Record<string, string> = {
  max_active_job_posts: "Offerte di lavoro attive",
  max_applications_per_job: "Candidature per offerta",
  max_companies: "Aziende",
  max_team_members: "Membri del team",
};

/**
 * Returns true when the current usage has reached or exceeded the limit.
 * Returns false unconditionally when limit === -1 (unlimited).
 */
export const isAtLimit = (current: number, limit: number): boolean => {
  if (limit === -1) return false;
  return current >= limit;
};

/**
 * Returns a human-readable label for a plan limit key.
 * Falls back to the raw key when no label is defined.
 */
export const limitLabel = (limitKey: string): string => {
  return LIMIT_LABELS[limitKey] ?? limitKey;
};
